import { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { Menu, X, Zap } from 'lucide-react';
import { NAV_LINKS } from '../mock';

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location]);

  return (
    <header className="fixed top-4 left-0 right-0 z-50 px-4">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="bg-brand-dark text-brand-cream rounded-full pl-6 pr-3 py-3 flex items-center justify-between shadow-lg shadow-brand-dark/10 border border-brand-deep">
          <Link to="/" className="flex items-center gap-2.5 group">
            <img src="/logo_icon.png" alt="E Drives Logo" className="w-9 h-9 object-contain transition-transform duration-300 group-hover:scale-105" />
            <span className="text-xl font-bold tracking-tight heading-display">E Drives</span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.path}
                to={l.path}
                end={l.path === '/'}
                className={({ isActive }) =>
                  `px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 ${
                    isActive
                      ? 'bg-brand-deep text-brand-lime'
                      : 'text-brand-cream/85 hover:text-brand-lime hover:bg-brand-deep/60'
                  }`
                }
              >
                {l.name}
              </NavLink>
            ))}
          </nav>

          <button
            className="md:hidden w-10 h-10 rounded-full bg-brand-deep flex items-center justify-center"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>

        {open && (
          <div className="md:hidden mt-2 bg-brand-dark text-brand-cream rounded-3xl p-3 shadow-xl border border-brand-deep">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.path}
                to={l.path}
                end={l.path === '/'}
                className={({ isActive }) =>
                  `block px-4 py-3 text-sm font-medium rounded-2xl ${
                    isActive ? 'bg-brand-deep text-brand-lime' : 'text-brand-cream/85 hover:bg-brand-deep/40'
                  }`
                }
              >
                {l.name}
              </NavLink>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}
